var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-alert"},[_c('span',{staticClass:"close-button",on:{"click":_vm.closeAlert}},[_vm._v("x")]),_c('p',[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }